<template><div><h1>VUX V2.0.1 发布日志</h1>
<h2><a href="/zh-CN/components/loading.html">Loading</a></h2>
<ul><li>[fix] i18n 无配置</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复type未定义的问题</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.0.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.0.1-195.vue?1962f970